module.exports = __webpack_public_path__ + "static/media/nodata.b88bccf0.png";